export enum LookupAddressNext {
  RETRIEVE = 'Retrieve',
  FIND = 'Find'
}
